import CreditNoteForm from "./CreditNoteForm";

function CreditNoteEdit() {
  return <CreditNoteForm mode="edit" />;
}

export default CreditNoteEdit;
